import { z } from 'zod'
import { FREE_SCAN_CTAS, FREE_SCAN_SHARE_METHODS } from '@/lib/analytics/events'

/**
 * A step the visitor takes on the free scan's pages, as the browser reports it to the funnel beacon
 * (`POST /api/tools/vis-scan/[slug]/event`, R6.6 AC-11). Client-safe on purpose: zod and the event
 * registry's constant arrays only, so the page posts the type the route parses. The enums are the
 * registry's, never re-spelled here.
 */

/**
 * Which surface a free-scan step came from: `/audit` or the result page. The one list: the scan
 * start, the email request and this beacon all build their `entry` from it. It lives in this leaf,
 * not in `free-scan-lead-request.ts`, because that file imports `validators.ts` (the token cap) and
 * `validators.ts` needs the list as a value, which would close a runtime import cycle.
 */
export const FREE_SCAN_ENTRIES = ['audit', 'result'] as const

const entry = z.enum(FREE_SCAN_ENTRIES)

export const freeScanPageEventSchema = z.discriminatedUnion('event', [
  z.object({ event: z.literal('recipe_viewed'), entry }),
  z.object({ event: z.literal('cta_clicked'), entry, cta: z.enum(FREE_SCAN_CTAS) }),
  z.object({ event: z.literal('shared'), entry, method: z.enum(FREE_SCAN_SHARE_METHODS) }),
])

export type FreeScanPageEvent = z.infer<typeof freeScanPageEventSchema>
